'use client';

/**
 * Last-resort boundary for errors thrown in the root layout itself. It replaces
 * the whole document, so it cannot rely on the app's global stylesheet.
 */
export default function GlobalError({ reset }) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 16,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          background: '#f5f5f7',
          color: '#1d1d1f',
        }}
      >
        <div
          role="alert"
          style={{
            maxWidth: 440,
            textAlign: 'center',
            background: '#fff',
            padding: '40px 28px',
            borderRadius: 20,
            boxShadow: '0 16px 40px rgba(16,24,40,.14)',
          }}
        >
          <h1 style={{ fontSize: '1.35rem', margin: 0 }}>The application hit a problem</h1>
          <p style={{ color: '#6b7280', lineHeight: 1.6 }}>
            Please reload the page. If the problem continues, contact support.
          </p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              minHeight: 44,
              padding: '0 20px',
              border: 0,
              borderRadius: 10,
              background: '#0a3c97',
              color: '#fff',
              fontSize: '0.95rem',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Reload
          </button>
        </div>
      </body>
    </html>
  );
}
